import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { Filing, FilingType } from '../Compliance/compliance.model';
import { ComplianceService } from '../Compliance/compliance.service';

import { FormsModule } from '@angular/forms';
import { ModalWrapperComponent } from '../../UI-Lib/Modal-Wrapper/modalWrapper.component';

declare const _: any;

@Component({
    selector: 'add-filing-modal',
    templateUrl: './add-filing.component.html',
    imports: [FormsModule, ModalModule, ModalWrapperComponent],
})
export class AddFilingModalComponent {
    constructor(private complianceService: ComplianceService) {
        this.addFiling = new EventEmitter();
    }

    @Input() filingTypes: FilingType[];
    @Input() annualYearID: number;
    @Input() isMergedParcel: boolean;
    @Output('add') addFiling: EventEmitter<Filing>;
    @ViewChild('addFilingModal', { static: true }) addFilingModal: ModalDirective;

    newFiling: Filing;

    filingTypesDropdown: FilingType[];
    creatingFiling: boolean = false;
    priorYearMiscFilingDescription: string = null;

    show(): void {
        this.addFilingModal.show();
    }

    showModalInit(): void {
        this.filingTypesDropdown = _.reject(
            this.filingTypes,
            (x) => x.filingTypeId == Core.FilingTypes.PPReturn && this.isMergedParcel,
        );
        this.newFiling = new Filing();
        this.newFiling.annualYearID = this.annualYearID;
        this.newFiling.filingTypeId = this.filingTypesDropdown[0].filingTypeId;

        // Retrieve the description of the prior year Misc Filing, if any. Will return null if not found.
        this.complianceService
            .getDescriptionOfPriorYearFiling(this.annualYearID, Core.FilingTypes.MiscFiling)
            .then((description) => {
                this.priorYearMiscFilingDescription = description;
                this.filingTypeChanged();
            });
    }

    filingTypeChanged(): void {
        // If MiscFiling, set Description to prior year value. Otherwise, set Description to null (empty)
        this.newFiling.description =
            this.newFiling.filingTypeId === Core.FilingTypes.MiscFiling ? this.priorYearMiscFilingDescription : null;
    }

    save(): void {
        this.creatingFiling = true;
        this.complianceService
            .createFiling(this.newFiling)
            .then((filing) => {
                filing.filingType = _.find(this.filingTypesDropdown, { filingTypeId: filing.filingTypeId });
                this.addFiling.emit(filing);
                this.addFilingModal.hide();
            })
            .finally(() => {
                this.creatingFiling = false;
            });
    }
}
